export const userFormSchema = {
  status: 200,
  result: {
    properties: {
      name: null,
      label: null,
      description: null,
      components: [
        {
          id: null,
          key: "02bd490e31824025b04a88eda88afa01",
          ref: "account",
          type: "panel",
          required: false,
          label: "Account Details",
          labelKey: "USER.U000",
          components: [
            {
              id: null,
              key: "firstName",
              type: "textfield",
              required: false,
              label: "First Name",
              labelKey: "USER.U001",
              placeholder: "First Name",
              placeholderKey: "USER.U001",
              default: null,
              validate: true,
              validators: [{ callback: "required" }],
            },
            {
              id: null,
              key: "lastName",
              type: "textfield",
              required: false,
              label: "Last Name",
              labelKey: "USER.U002",
              placeholder: "Last Name",
              placeholderKey: "USER.U002",
              default: null,
              validate: true,
              validators: [{ callback: "required" }],
            },
            {
              id: null,
              key: "email",
              type: "textfield",
              required: false,
              label: "Email (user name)",
              labelKey: "USER.U003",
              placeholder: "Email",
              placeholderKey: "USER.U013",
              default: null,
              validate: true,
              validators: [{ callback: "required" }, { callback: "email" }],
            },
            {
              id: null,
              key: "password",
              type: "password",
              required: false,
              label: "Password",
              labelKey: "USER.U004",
              placeholder: "Password",
              placeholderKey: "USER.U004",
              default: null,
              validate: true,
              validators: [{ callback: "strongPassword" }],
            },
            {
              id: null,
              key: "cpassword",
              type: "password",
              required: false,
              tansit: false,
              label: "Confirm Password",
              labelKey: "USER.U005",
              placeholder: "Confirm Password",
              placeholderKey: "USER.U005",
              default: null,
              validate: true,
              validators: [{ callback: "mustMatch" }],
            },
          ],
        },
        {
          id: null,
          key: "02bd490e31824025b04a88eda88afa02",
          ref: "role",
          type: "panel",
          required: false,
          label: "User Roles",
          labelKey: "USER.U006",
          components: [
            /*  {
              id: null,
              key: "roles",
              type: "checkbox-group",
              label: "",
              default: false,
              data: {
                values: [
                  { label: "Admin",
                    labelKey: "USER.U007",
                    value: "admin" },
                  { label: "User",
                    labelKey: "USER.U008",
                    value: "bouser" },
                ],
              },
              multiSubField: {
                includeNamedKey: "role",
                keys: [{ key: "checked" }],
              },
              multiValue: true,
            }, */
            {
              id: null,
              type: "form-array",
              key: "roles",
              components: [
                {
                  id: null,
                  key: "store",
                  type: "dropdown",
                  label: "Store",
                  labelKey: "USER.U009",
                  placeholder: "Select Store",
                  placeholderKey: "USER.U014",
                  required: true,
                  data: {
                    values: [],
                  },
                  clearable: false,
                  validators: [{ callback: "required" }],
                },
                {
                  id: null,
                  key: "role",
                  type: "dropdown",
                  label: "Role",
                  labelKey: "USER.U010",
                  placeholder: "Select Role",
                  placeholderKey: "USER.U015",
                  required: true,
                  data: {
                    values: [
                      { label: "Admin", labelKey: "USER.U007", value: "admin" },
                      { label: "User", labelKey: "USER.U008", value: "bouser" },
                    ],
                  },
                  clearable: false,
                  validators: [{ callback: "required" }],
                },
              ],
              multiValue: true,
            },
          ],
        },
      ],
    },
  },
};
